var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7824 15.3328C18.3896 15.3328 18.0168 15.4111 17.6705 15.5357C17.8602 15.113 17.9874 14.6426 17.9874 14.1403C17.9874 12.1527 15.9998 10.662 15.9998 10.662C15.9998 10.662 14.0123 12.1527 14.0123 14.1403C14.0123 14.6425 14.1395 15.113 14.3291 15.5357C13.9828 15.4112 13.61 15.3328 13.2173 15.3328C11.2297 15.3328 9.73901 17.3203 9.73901 17.3203C9.73901 17.3203 11.2297 19.308 13.2173 19.308C14.3826 19.308 15.3765 18.625 15.9999 18.0596C16.6233 18.6249 17.6172 19.308 18.7825 19.308C20.7701 19.308 22.2608 17.3203 22.2608 17.3203C22.2608 17.3203 20.77 15.3328 18.7824 15.3328V15.3328Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 6.26086L16.4109 7.52436H17.7395L16.6648 8.30536L17.0751 9.56885L16.0004 8.78786L14.9257 9.56885L15.3359 8.30536L14.2612 7.52436H15.5898L16.0004 6.26086Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9472 8.47083L11.7371 9.18195L12.6576 8.65057L12.2253 9.62151L13.0151 10.3328L11.9581 10.2216L11.5259 11.1926L11.3047 10.153L10.2478 10.0419L11.1682 9.51039L10.9472 8.47083Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24951 12.1692L8.28914 12.3901L8.82057 11.4697L8.9317 12.5266L9.9712 12.7477L9.00032 13.18L9.11145 14.2369L8.40014 13.4472L7.42926 13.8795L7.9607 12.959L7.24951 12.1692Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0519 8.47083L20.2621 9.18195L19.3417 8.65057L19.7739 9.62151L18.9841 10.3328L20.0411 10.2216L20.4734 11.1926L20.6945 10.153L21.7514 10.0419L20.8311 9.51039L21.0519 8.47083Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7505 12.1692L23.7109 12.3901L23.1795 11.4697L23.0683 12.5266L22.0288 12.7477L22.9997 13.18L22.8886 14.2369L23.5999 13.4472L24.5707 13.8795L24.0393 12.959L24.7505 12.1692Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 24.8733C17.5797 24.8733 19.035 24.3465 20.2024 23.4602H11.7996C12.9669 24.3465 14.4221 24.8733 16.0009 24.8733Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62329 20.6993C9.8441 21.2047 10.1241 21.678 10.453 22.1124H21.5479C21.8767 21.6781 22.1567 21.2047 22.3776 20.6993H9.62329Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacao);
export default __webpack_public_path__ + "static/media/macao.5598b792.svg";
export { ForwardRef as ReactComponent };